var Tools = require('../../deploynaut/js/tools.jsx');
var Integrations = require('./Integrations.jsx');

Tools.install(Integrations, 'Integrations');

